import * as mainActionTypes from '../mainActionTypes';

export default function suggestedNameReducer(state = {}, action) {
  const { type, payload } = action;
  let currentState = state;
  switch (type) {
    case mainActionTypes.SET_PICKED_SUGGESTION:
      currentState = { ...state, ...payload };
      break;
    case mainActionTypes.SET_MOCK_LOGO_SVG:
      currentState = { ...state, ...payload };
      break;
    default:
  }
  return currentState;
}
